"use client";

import { PropsWithChildren, Suspense, use } from "react";
import { initBrowserMocks } from "@/mocks/mswInit";
import getConfig from "@/utils/config";

const { publicRuntimeConfig } = getConfig();

/**
 * We only initialize the client-side mocks here. The server-side mocks are initialized
 * in app/layout.tsx. Immense effort was expended in trying to initialize both runtimes' MSW
 * from a central place, but with no luck.
 */
let mswInitPromise: Promise<any> = Promise.resolve();
if (
  typeof window !== "undefined" &&
  publicRuntimeConfig.API_MOCKING === "enabled"
) {
  mswInitPromise = initBrowserMocks();
}

/**
 * Example adapted from:
 * https://github.com/mswjs/examples/blob/d2c3e0364b63dd973cee2451066878254e16738b/examples/with-next/app/msw-provider.tsx
 */
function MSWProviderWrapper({ children }: PropsWithChildren) {
  use(mswInitPromise);
  return children;
}

export default function MSWProvider({ children }: PropsWithChildren) {
  // If MSW is enabled, we need to wait for the worker to start,
  // so we wrap the children in a Suspense boundary until it's ready.
  return (
    <Suspense fallback={null}>
      <MSWProviderWrapper>{children}</MSWProviderWrapper>
    </Suspense>
  );
}
